<script setup lang="ts">
import type { ParseKeys } from 'i18next';

defineProps<{
  currentValue: number;
  maxValue: number;
  subTitle: ParseKeys;
}>();
</script>

<template>
  <div class="relative self-center size-40" data-testid="progress-circle">
    <svg
      class="size-full"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="18"
        cy="18"
        r="16"
        fill="none"
        class="stroke-current text-gray-200"
        stroke-width="2"
      ></circle>

      <g v-if="maxValue" class="origin-center -rotate-90 transform">
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          class="stroke-current text-blue-600"
          stroke-width="2"
          stroke-dasharray="100"
          :stroke-dashoffset="100 - (currentValue * 100) / maxValue"
        ></circle>
      </g>
    </svg>

    <div
      class="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2"
    >
      <p
        class="text-center text-2xl font-bold text-gray-800"
        data-testid="progress-circle-value"
      >
        {{ maxValue ? `${currentValue}/${maxValue}` : `${currentValue}` }}
      </p>
      <p
        class="text-center text-sm text-gray-800"
        data-testid="progress-circle-subtitle"
      >
        {{ $t(subTitle) }}
      </p>
    </div>
  </div>
</template>
